import { ConformityDependency } from "../interfaces/Organization";
import { MRequirementEvaluation } from "./requirement-evaluation.model";

export class MConformityDependency {
  public id: number = null;
  public fatherId: number = null;
  public requirementId: number = null;
  public prelationId: number = null;
  public evaluationFather: MRequirementEvaluation;

  constructor(dependency: ConformityDependency) {
    this.id = dependency.id;
    this.prelationId = dependency.tipo_prelacion_id;
    this.fatherId = dependency.requisito_padre_id;
    this.requirementId = dependency.requisito_id;
    this.evaluationFather = dependency.evaluacion_padre
      ? new MRequirementEvaluation(dependency.evaluacion_padre)
      : null;
  }
}
